import { Cell } from '@pelckmans/elementis/components/table';
import TimeIcon from '@pelckmans/elementis/icons/time';

export default function TimeCell({ duration, highlighted }: { duration?: number; highlighted?: boolean }) {
  const formatDuration = (seconds: number): string => {
    if (seconds === 0) return '';
    if (seconds < 60) return `${seconds}s`;
    if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}m ${remainingSeconds}s`;
    }

    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h ${remainingMinutes}m`;
  };

  const durationStr = duration ? formatDuration(duration) : '';

  return (
    <Cell highlighted={highlighted}>
      {duration ? <Cell.Text title={durationStr} startAdornment={<TimeIcon data-testid="time-icon" />} /> : null}
    </Cell>
  );
}
